import axios from "axios";


export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async accountForm(context, payload) {
      try {
        const response = await axios.post("/account/delivery-information", payload, 
          {
            headers: {
              Authorization: "Bearer " + context.rootGetters["authModule/auth"].token
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
        throw error.response.data;
      }
    },

    async loadAccount(context){
      try {
        const response = await axios.get("/account/delivery-information", 
          {
            headers: {
              Authorization: "Bearer " + context.rootGetters["authModule/auth"].token
            }
          }
        );
        return response.data;
      } catch (error) {
        console.log(error)
        throw error.response.data;
      }      
    },

    async resetPasswordForm(context, payload){
      try {
        const response = await axios.put("/account/reset-password", payload,
          {
            headers: {
              Authorization: "Bearer " + context.rootGetters["authModule/auth"].token
            }
          }
        );
        return response.data;
      } catch (error) {
        throw error.response;
      }
    },

  }
};
